var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const SelectedDocument = (props) => {
    const { handleDeleteDocument, doc } = props, rest = __rest(props, ["handleDeleteDocument", "doc"]);
    return (React.createElement("div", Object.assign({ className: 'document-item' }, rest),
        React.createElement("span", { className: 'remove-selected-document', title: 'Remove Document from Selection', onClick: handleDeleteDocument },
            React.createElement("span", { className: 'fas fa-times' })),
        React.createElement("span", { className: 'panel-link', onClick: () => {
                const win = window.open(`/document/${doc.id}`, '_blank');
                if (win)
                    win.focus();
            } }, doc.name)));
};
export default SelectedDocument;
